<template>
  <div class="comments-container">
    <!-- 主评论输入框 -->
    <div class="main-comment-box">
      <div class="main-comment-box-title">
        <BaseIcon icon="md-chatbubbles" :size="16" style="margin-right:5px;" />
        添加评论</div>
      <Input
        v-model="mainComment"
        type="textarea"
        :rows="5"
        placeholder="写下你的评论..."
        auto-focus
        show-word-limit
      />
      <div class="submit-row">
        <Button type="primary" :loading="submitting" @click="handleMainSubmit">提交</Button>
      </div>
    </div>

    <!-- 评论列表 -->
    <div class="comments-list">
      <div v-if="treeComments.length === 0" class="empty-comments">
        暂无评论，快来发表第一条评论吧~
      </div>
      <comment-item
        v-for="comment in treeComments"
        :key="comment.id"
        :comment="comment"
        :submitting="submitting"
        :level="1"
        :session="session"
        :active-reply-id="activeReplyId"
        :active-edit-id="activeEditId"
        @reply="handleReply"
        @edit="handleEdit"
        @delete="handleDelete"
        @toggle-reply="handleToggleReply"
        @toggle-edit="handleToggleEdit"
        @toggle-comment-visible="handleToggleVisible"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CommentItem from './comments-item.vue';

export default {
  name: 'Comments',
  components: {
    CommentItem
  },
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainComment: '',
      activeReplyId: null, // 当前激活的回复框ID
      activeEditId: null // 当前激活的编辑框ID
    };
  },
  computed: {
    ...mapGetters('session', ['session']),
    
    // 将评论列表转换为树状结构
    treeComments() {
      if (!this.comments || this.comments.length === 0) {
        return [];
      }

      // 创建一个映射表
      const commentMap = new Map();
      const rootComments = [];

      // 先创建所有节点
      this.comments.forEach(comment => {
        commentMap.set(comment.id, {
          ...comment,
          children: []
        });
      });

      // 建立父子关系
      this.comments.forEach(comment => {
        const node = commentMap.get(comment.id);
        if (comment.reply_id && commentMap.has(comment.reply_id)) {
          // 有父评论，添加到父评论的children中
          const parent = commentMap.get(comment.reply_id);
          parent.children.push(node);
        } else {
          // 顶层评论
          rootComments.push(node);
        }
      });

      // 递归排序函数
      const sortByTime = (comments) => {
        comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        comments.forEach(comment => {
          if (comment.children && comment.children.length > 0) {
            sortByTime(comment.children);
          }
        });
      };

      // 对所有层级按时间排序
      sortByTime(rootComments);

      return rootComments;
    }
  },
  methods: {
    handleMainSubmit() {
      if (!this.mainComment.trim()) {
        this.$Message.warning('请输入评论内容');
        return;
      }

      this.$emit('submit', {
        content: this.mainComment,
        reply_id: null
      });

      this.mainComment = '';
    },

    handleReply({ commentId, content }) {
      this.$emit('reply', {
        content,
        reply_id: commentId
      });
    },

    handleEdit({ commentId, content }) {
      this.$emit('edit', {
        comment_id: commentId,
        content
      });
    },

    handleDelete(commentId) {
      this.$emit('delete', commentId);
    },

    handleToggleReply(commentId) {
      // 如果点击的是当前激活的回复框，则关闭；否则激活新的
      if (this.activeReplyId === commentId) {
        this.activeReplyId = null;
      } else {
        this.activeReplyId = commentId;
        this.activeEditId = null; // 关闭编辑框
      }
    },

    handleToggleEdit(commentId) {
      // 如果点击的是当前激活的编辑框，则关闭；否则激活新的
      if (this.activeEditId === commentId) {
        this.activeEditId = null;
      } else {
        this.activeEditId = commentId;
        this.activeReplyId = null; // 关闭回复框
      }
    },

    handleToggleVisible(commentId) {
      this.$emit('toggle-comment-visible', commentId);
    }
  }
};
</script>

<style scoped lang="less">
.comments-container {
  width: 100%;
  height:100%;
  position:relative;
  overflow:hidden;
  
  .main-comment-box-title{
    margin-bottom:5px;
    color:var(--text1);
    font-weight: bold;
  }

  .main-comment-box {
    padding: 15px;
    background:#00000033;
    margin-bottom:10px;

    .ivu-input{
        background:#ffffffaa !important;
    }   

    .submit-row {
      display: flex;
      justify-content: flex-end;
      margin-top: 12px;
    }
  }

  .comments-list {
    height:calc(100% - 220px);
    overflow-y:auto;
    padding:0 10px;
    background:#00000033;
    .empty-comments {
      text-align: center;
      padding: 40px 0;
      color: #ddd;
      font-size: 14px;
    }
  }

  /* 美化滚动条 */
  .comments-list {
    scrollbar-width: thin;
    scrollbar-color: var(--text1) var(--bg2);
  }

  .comments-list::-webkit-scrollbar {
    width: 8px;
    background: #11111111;
    border-radius: 6px;
  }

  .comments-list::-webkit-scrollbar-thumb {
    background: var(--primary);
    border-radius: 6px;
    min-height: 30px;
  }

  .comments-list::-webkit-scrollbar-thumb:hover {
    background: #6982ff;
  }
}
</style>

